
import { Trip } from '@/Models/Trip';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { $api } from '@/common/apiService';

export default defineComponent({
  name: 'TripTile',
  props: {
    trip: {
      type: Object as PropType<Trip>,
      required: true,
    },
  },
  data() {
    return {
      image: null as string | null,
    };
  },
  async mounted() {
    const token = this.$store.getters.getSasToken;
    if (this.trip.coverImageId != null) {
      const img = await $api.images.get(this.trip.coverImageId);
      this.image = img ? img.uri + '?' + token : null;
    } else if (this.trip.locationImageId != null) {
      const img = await $api.images.get(this.trip.locationImageId);
      this.image = img ? img.uri + '?' + token : null;
    }
  },
  methods: {
    formatDateRange(startDate: string, endDate: string): string {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' };
      const s = start.toLocaleDateString('da-DK', opts);
      const e = end.toLocaleDateString('da-DK', { ...opts, year: 'numeric' });
      return `${s} – ${e}`;
    },
  },
});
